"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
require("../../../../core");
require("../../../../components");
const getColumns = (t) => [
    {
        field: 'priority',
        title: t('priorityOrderDialog|columns|priority'),
        width: 100,
    },
    {
        field: 'name',
        title: t('priorityOrderDialog|columns|name'),
    },
    {
        field: 'description',
        title: t('priorityOrderDialog|columns|description'),
    },
];
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map